import { IObservable, Observable } from 'thrive-observable-react'

//servicecs
import { isLightColor } from '../utils/colours';

//components
import { IContentTile } from 'thrive-components';

//interfaces
import { IUserDetailsForm } from '../interfaces/FormData';
import { ICreateAppPayload } from '../interfaces/api';
import { SignUpSteps } from '../interfaces/Navigation';


class SignUpAppConfigService {
    public currentStep: IObservable<SignUpSteps> = Observable<SignUpSteps>(SignUpSteps.ONBOARDING);
    public cmsUrl: IObservable<string | null> = Observable<string | null>(null);
    public createAppForm: IObservable<ICreateAppPayload | null> = Observable<ICreateAppPayload | null>(null);

    //app style and content
    public colour: IObservable<string> = Observable<string>('203554');
    public fontColour: IObservable<string> = Observable("#ffffff");
    public appName: IObservable<string> = Observable<string>("Welcome! 🎊");
    public orgShortName: IObservable<string> = Observable<string>("");
    public contentTiles: IObservable<IContentTile[]> = Observable<IContentTile[]>([] as IContentTile[]);
    public code: IObservable<string> = Observable<string>("");


    public checkIfUserIsVerified() {
        return !!this.code?.value;
    }

    public setUpdateCode(code: string) {
        this.code.update(code);

                
        this.createAppForm.update((current: ICreateAppPayload | null): ICreateAppPayload => ({
            ...(current ?? ({} as ICreateAppPayload)),
            code: code
        }));
    }

    public getCurrentStep() {
        return this.currentStep.value;
    }

    public setCurrentStep = (step: SignUpSteps) => {
        this.currentStep.update(step);
    }

    public getCmsLink() {
        return this.cmsUrl?.value ?? null;
    }
    
    public setAppName = (name:string) => {
        this.appName.update(name);
        
        this.createAppForm.update((current: ICreateAppPayload | null): ICreateAppPayload => ({
            ...(current ?? ({} as ICreateAppPayload)),
            appName: name
        }));
    }

    public setOrgShortName = (name:string) => {
        this.orgShortName.update(name);

        this.createAppForm.update((current: ICreateAppPayload | null): ICreateAppPayload => ({
            ...(current ?? ({} as ICreateAppPayload)),
            orgShortName: name
        }));
    }

    public updateContentTiles = (content?: IContentTile[]) => {
        const fallbackContent = content ?? [] as IContentTile[];

        this.contentTiles.update(fallbackContent);

        const orderedIds = fallbackContent.map(tile => tile.id);

        this.createAppForm.update((current: ICreateAppPayload | null): ICreateAppPayload => ({
            ...(current ?? ({} as ICreateAppPayload)),
            orderedContentIds: orderedIds
        }));
    };

    public saveUserDetailsToForm = (formData: IUserDetailsForm) => {
        this.createAppForm.update((current: ICreateAppPayload | null): ICreateAppPayload => ({
            ...(current ?? ({} as ICreateAppPayload)),
            ...formData
        }));
    };

    public updateCmsUrl = (cmsUrl: string) => {
        this.cmsUrl.update(cmsUrl);
    }

    public setColour = (color: string) => {
        this.colour.update(color);
    
        const isLight = isLightColor(color);
    
        this.fontColour.update(
            isLight ? "#343D4C" : "#ffffff"
        );

        this.createAppForm.update((current: ICreateAppPayload | null): ICreateAppPayload => ({
            ...(current ?? ({} as ICreateAppPayload)),
            themeHex: `#${color}`
        }));
    }
}

const SUACService = new SignUpAppConfigService();

export {SUACService, SignUpAppConfigService};